import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  variant = 'default',
  padding = 'default',
  shadow = 'default',
  hover = false,
  clickable = false,
  onClick,
  ...props 
}) => {
  const baseClasses = 'bg-white rounded-xl border transition-all duration-200';
  
  const variants = {
    default: 'border-gray-200',
    elevated: 'border-gray-100',
    outlined: 'border-2 border-gray-200',
    ghost: 'border-transparent bg-gray-50'
  };

  const shadows = {
    none: '',
    sm: 'shadow-sm',
    default: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl'
  };

  const paddings = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8',
    xl: 'p-10'
  };

  const hoverClasses = hover 
    ? 'hover:shadow-lg hover:scale-105 hover:-translate-y-1' 
    : '';

  const clickableClasses = clickable 
    ? 'cursor-pointer' 
    : '';

  const classes = `${baseClasses} ${variants[variant]} ${shadows[shadow]} ${paddings[padding]} ${hoverClasses} ${clickableClasses} ${className}`;

  return (
    <div 
      className={classes} 
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card; 